import { render, staticRenderFns } from "./GroupMemberPopover.vue?vue&type=template&id=3d01189d&scoped=true&"
import script from "./GroupMemberPopover.vue?vue&type=script&lang=ts&"
export * from "./GroupMemberPopover.vue?vue&type=script&lang=ts&"
import style0 from "./GroupMemberPopover.vue?vue&type=style&index=0&id=3d01189d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d01189d",
  null
  
)

export default component.exports